export const setItem = (key: string, value: any): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.warn('Error', error);
  }
};

export const getItem = (key: string): any => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn('Error', error);
  }
};

export const removeItem = (key: string): any => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn('Error', error);
  }
};
